import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FORM_GROUP_LABEL } from '../../constants/translationLabels/formElements';
import { RHFAutocomplete } from '../../share/rhf';

const GroupsList = ({ control, setValue }) => {
    const { t } = useTranslation('common');
    const groups = useSelector((state) => state.groups.groups);

    return (
        <RHFAutocomplete
            control={control}
            name="group"
            options={groups || []}
            label={t(FORM_GROUP_LABEL)}
            getOptionLabel={(group) => (group ? group.title : '')}
            className="schedule-form_group"
            disabled={isEmpty(groups)}
            onAfterChange={(value) => {
                if (value) {
                    setValue('teacher', null);
                    setValue('department', null);
                }
            }}
        />
    );
};

export default GroupsList;
